module.exports = __webpack_public_path__ + "img/cta.5cea49db.png";